/** @module ProductSpec/SizeChartSubSizesRenderer */
define([
	"dojo/_base/declare",
	"Apparel/ProductSize/_SizesRenderer"
], function(declare,_SizesRenderer) {

	return declare(_SizesRenderer, {
		/**
		 * @override
		 * Return size range for size chart
		 */
		getSizeRange: function(ctx) {
			return ctx.cache.get(ctx.getNode().SubrangeSizeRange);
		}
	});
});